import type { MessageKey } from './message-keys';
import { EN_MESSAGES } from './locales/en';
import { ES_MESSAGES } from './locales/es';
import { RU_MESSAGES } from './locales/ru';
import { ZH_HANS_MESSAGES } from './locales/zh-Hans';
import type { AppLocale, MessageTemplate } from './types';

export type MessageCatalog = Readonly<Record<MessageKey, MessageTemplate>>;

export const MESSAGE_CATALOGS: Readonly<Record<AppLocale, MessageCatalog>> = Object.freeze({
  en: EN_MESSAGES,
  'zh-Hans': ZH_HANS_MESSAGES,
  ru: RU_MESSAGES,
  es: ES_MESSAGES,
});
